<template>
  <div class="camera">
    <div class="controlWindow">
      <!-- <input type="hidden" name="suuid" id="suuid" value="{{ .suuid }}">
            <input type="hidden" name="port" id="port" value="{{ .port }}">-->

      <input type="hidden" name="suuid" id="suuid" value="test1" />
      <input type="hidden" name="port" id="port" value=":8888" />
      <video
        id="livestream"
        style="width: 850px; height: 450px"
        controls
        autoplay
        muted
      ></video>
    </div>
  </div>
</template>

<script>

let media = require('@/utils/media.js')
import axios from 'axios'


export default {

  data() {
    return {
      verbose: true,
      streamingStarted: false,
      ms: new MediaSource(),
      queue: [],
      ws: null,
      potocol: null,
      livestream: null,
      sourceBuffer: null,
      ip: '90b418316068ca45.natapp.cc:4196'
    }
  },
  props: {
    deviceEUI: {
      required: true,
      type: String
    }
  },
  beforeCreate() {

  },
  created() {
    axios.get('config.json').then(res => {
      this.ip = res.data[this.$store.getters.currentTenant]
    }).then(() => {
      if (this.ms == null)
        this.ms = new MediaSource();
        this.$nextTick(function () {

          if (!Uint8Array.prototype.slice) {
            Object.defineProperty(Uint8Array.prototype, 'slice', {
              value: function (begin, end) {
                return new Uint8Array(Array.prototype.slice.call(this, begin, end));
              }
            });
          }
          this.potocol = 'ws';
          if (location.protocol.indexOf('s') >= 0) {
            this.potocol = 'wss';
          }


          this.livestream = document.getElementById('livestream');

          this.ready();
        })
    })


  },
  beforeDestroy() {
    this.cancelPlay()
  },
  methods: {
    pushPacket(arr, sb) {
      let view = new Uint8Array(arr);
      let sourceBuffer2 = sb;

      if (this.verbose) {
        console.log("got", arr.byteLength, "bytes.  Values=", view[0], view[1], view[2], view[3], view[4]);
      }
      let data = arr;
      if (!this.streamingStarted) {

        sourceBuffer2.appendBuffer(data);
        this.streamingStarted = true;
        return;
      }
      this.queue.push(data);

      if (this.verbose) {
        console.log("queue push:", this.queue.length);
      }
      if (!sourceBuffer2.updating) {

        this.loadPacket(sourceBuffer2);
      }
    },
    loadPacket(sb) {

      let sourceBuffer1 = sb;
      if (!sourceBuffer1.updating) {

        if (this.queue.length > 0) {
          let inp = this.queue.shift();
          if (this.verbose) {
            console.log("queue PULL:", this.queue.length);
          }
          let view = new Uint8Array(inp);
          if (this.verbose) {
            console.log("writing buffer with", view[0], view[1], view[2], view[3], view[4]);
          }
          sourceBuffer1.appendBuffer(inp);
        } else {
          this.streamingStarted = false;
        }
      }
    },
    opened() {
      let inputVal = this.deviceEUI; //$('#suuid').val();
      let decoded_arr = null;
      let mimeCodec = null;
      let mms = this.ms;
      let ps = this.pushPacket;
      let ut = this.Utf8ArrayToStr;
      let loadPacket = this.loadPacket;
      let ws1 = this.ws;
      let port = $('#port').val();


      this.ws = new WebSocket(this.potocol + "://" + this.ip + "/ws/live?suuid=" + inputVal);
      this.ws.binaryType = "arraybuffer";
      this.ws.onopen = function (event) {
        console.log('Connect');
      }
      this.ws.onmessage = (event) => {
        let data = new Uint8Array(event.data);
        if (data[0] == 9) {
          decoded_arr = data.slice(1);
          if (window.TextDecoder) {
            mimeCodec = new TextDecoder("utf-8").decode(decoded_arr);
          } else {
            mimeCodec = ut(decoded_arr);
          }
          if (this.verbose) {
            console.log('first packet with codec data: ' + mimeCodec);
          }
          this.sourceBuffer = mms.addSourceBuffer('video/mp4; codecs="' + mimeCodec + '"');
          this.sourceBuffer.mode = "segments"
          this.sourceBuffer.addEventListener("updateend", loadPacket(this.sourceBuffer));
        } else {
          ps(event.data, this.sourceBuffer);
        }
      };
    },
    Utf8ArrayToStr(array) {
      let out, i, len, c;
      let char2, char3;
      out = "";
      len = array.length;
      i = 0;
      while (i < len) {
        c = array[i++];
        switch (c >> 4) {
          case 7:
            out += String.fromCharCode(c);
            break;
          case 13:
            char2 = array[i++];
            out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
            break;
          case 14:
            char2 = array[i++];
            char3 = array[i++];
            out += String.fromCharCode(((c & 0x0F) << 12) |
              ((char2 & 0x3F) << 6) |
              ((char3 & 0x3F) << 0));
            break;
        }
      }
      return out;
    },
    startup() {
      this.ms.addEventListener('sourceopen', this.opened, false);
      this.livestream.src = window.URL.createObjectURL(this.ms);
    },
    ready() {
      this.startup();
      //this.suuid = $('#suuid').val();
      this.suuid = this.deviceEUI;
      $($.parseHTML(this.suuid, document, true)).addClass('active');
    },
    cancelPlay() {
      console.log(this.sourceBuffer)
      if (this.sourceBuffer && this.ms.readyState === 'open') {
        this.sourceBuffer.abort();
        this.ms.endOfStream();
        this.ws.close()
        window.URL.revokeObjectURL(this.livestream.src);
        media.destroy(this.deviceEUI)
      }
    },

  }

}
</script>

<style scoped>
.camera {
  overflow: hidden;
}
.videoWindow {
  float: left;
  width: 650px;
  height: 485px;
  margin-right: 10px;
  display: inline-block;
}
.controlWindow {
  float: left;
  width: 200px;
  height: 430px;
  background-color: #474752;
}
.controlTitle {
  margin: 0;
  height: 30px;
  color: #fff;
  line-height: 30px;
  padding-left: 10px;
  background-color: #2a292b;
  font-size: 12px;
}
/* .box-ctrl {
        height: 148px;
        width: 148px;
        background: url("../../../assets/images/Btn-diyuan.png") no-repeat center center;
        position: relative;
        margin: 30px auto;
    }
    .box-ctrl .el-button {
        border: none;
        margin: 0;
    }
    .box-ctrl .top {
        position: absolute;
        width: 100px;
        height: 46px;
        background: url("../../../assets/images/Btn-top.png") no-repeat center center;
        left: 24px;
        top: 2px;
    }
    .box-ctrl .top:hover {
        background: url("../../../assets/images/Btn-top-h.png") no-repeat center center;
    }

    .box-ctrl .right{
        position: absolute;
        width: 46px;
        height: 100px;
        background: url("../../../assets/images/Btn-right.png") no-repeat center center;
        right: 2px;
        top: 24px;
    }
    .box-ctrl .right:hover{
        background: url("../../../assets/images/Btn-right-h.png") no-repeat center center;
    }

    .box-ctrl .bottom{
        position: absolute;
        width: 100px;
        height: 46px;
        background: url("../../../assets/images/Btn-bottom.png") no-repeat center center;
        left: 24px;
        bottom: 2px;
    }
    .box-ctrl .bottom:hover{
        background: url("../../../assets/images/Btn-bottom-h.png") no-repeat center center;
    }

    .box-ctrl .left{
        position: absolute;
        width: 46px;
        height: 100px;
        background: url("../../../assets/images/Btn-left.png") no-repeat center center;
        left: 2px;
        top: 24px;
    }
    .box-ctrl .left:hover{
        background: url("../../../assets/images/Btn-left-h.png") no-repeat center center;
    }

    .box-ctrl .auto{
        position: absolute;
        width: 70px;
        height: 70px;
        background: url("../../../assets/images/Btn-auto.png") no-repeat center center;
        left:39px;
        top: 39px;
    }
    .box-ctrl .auto:hover{
        background: url("../../../assets/images/Btn-auto-h.png") no-repeat center center;
    }

    .box-cz{
        width: 148px;
        margin: 40px auto;
    }
    .box-cz .item{
        height: 30px;
        width: 148px;
        margin-bottom: 20px;
        background-color: #2a292b;
    }
    .box-cz .item>span{
        float: left;
    }
    .box-cz .item .item-l{
        width: 30px;
        height: 30px;
        background: url("../../../assets/images/ctrl-left.png");
    }
    .box-cz .item .item-l:hover{
        background: url("../../../assets/images/ctrl-left-h.png");
    }
    .box-cz .item .item-c{
        width: 88px;
        height: 28px;
        border-top: 1px solid #0e0d0d;
        border-bottom: 1px solid #0e0d0d;
        line-height: 30px;
        text-align: center;
        color: #c0c0d3;
        font-size: 12px;
    }
    .box-cz .item .item-r{
        width: 30px;
        height: 30px;
        background: url("../../../assets/images/ctrl-right.png");
    }
    .box-cz .item .item-r:hover{
        background: url("../../../assets/images/ctrl-right-h.png");
    } */
</style>